(function () {
    'use strict';

    angular
        .module('app')
        .factory('selectFilterFactory', selectFilterFactory);

    selectFilterFactory.$inject = [];

    function selectFilterFactory() {
        var apiList = {};
        var service = {
            getApi: getApi,
            registerApi: registerApi,
            removeApi: removeApi,
        };

        return service;

        function getApi(key) {
            return key && key.length && typeof apiList[key] !== 'undefined'
                ? apiList[key]
                : {};
        }

        function registerApi(key, api) {
            if (key && key.length) {
                apiList[key] = api;
            }
        }

        function removeApi(key) {
            if (key && key.length && typeof apiList[key] !== 'undefined') {
                delete apiList[key];
            }
        }
    }
})();